import MainscreenAr from './components/comp/AR/screens/MainscreenAr';
function App() {
	// const container = useSelector((state) => state);
	// const lang = window.localStorage.getItem('lang');
	return (
		<div>
			<MainscreenAr />
		</div>
	);
}
export default App;
